import React, { SFC } from "react";
import withContentWrap, { PropsType as WithContentWrapProps } from "../../hoc/withContentWrap";
import withTheme, { PropsType as withThemeProps } from "../../hoc/withTheme";
import withVerticalSpacing, { PropsType as WithVerticalSpacingProps } from "../../hoc/withVerticalSpacing";
import Icon from "../Icon";
import "./style.scss";

type PropsType = WithVerticalSpacingProps &
    HTMLProps<HTMLDivElement> &
    withThemeProps &
    WithContentWrapProps & {
        align?: "left" | "right";
        icon?: string;
        text?: string;
        title?: string;
        src?: string;
        srcSet?: string;
    };

const Header = (props): SFC => {
    const className = `Header Header--${props.align ? props.align : "left"}`;
    const theme = props.theme === undefined ? "inherit" : props.theme.fill;

    return (
        <div id={props.id} className={className} style={{ color: theme }}>
            <div className="Header__wrap">
                {props.src && (
                    <div className="Header__image">
                        <div className="Header__image-wrap">
                            <img src={props.src} srcSet={props.srcSet} alt={props.title} />
                        </div>
                    </div>
                )}
                {!props.src && (
                    <div className="Header__icon">
                        <div className="Header__icon-wrap">{props.icon && <Icon customSvg={props.icon} />}</div>
                    </div>
                )}
                <div className="Header__text">
                    <div className="Header__text-wrap">
                        {props.title && <h2>{props.title}</h2>}
                        {props.text && <p>{props.title}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withTheme(withVerticalSpacing(withContentWrap(Header)));
